import React, { useEffect, useRef } from 'react';
import { Box, Button, Modal, Typography, TextField, CircularProgress } from '@mui/material';

interface PinModalProps {
  isOpen: boolean;
  onClose: (event : any, reason : any) => void;
  pin: string;
  setPin: React.Dispatch<React.SetStateAction<string>>;
  pinError: string;
  handlePinSubmit: () => void;
  pinAvailable: boolean;
}

const PinModal: React.FC<PinModalProps> = ({ isOpen, onClose, pin, setPin, pinError, handlePinSubmit, pinAvailable }) => {
  const refreshPage = () => {
    window.location.reload();
  };
  
  const pinInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen && pinAvailable && pinInputRef.current) {
      pinInputRef.current.focus();
    }
  }, [isOpen, pinAvailable]);

  const handlePinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPin(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handlePinSubmit();
    }
  };

  const defaultModelContent = (
    <Box className="pin-modal-box">
      <Button
        sx={{
          color: 'black',
          padding: '5px 10px',
          minWidth: 'auto',
          '&:hover': {
            backgroundColor: '#d3d3d3',
          },
        }}
        onClick={refreshPage}
        className="close-button"
      >
        X
      </Button>
      <Box className="background-checks">
        {/* Placeholder 1 */}
        <Box className="background-checks-text">
          <Typography variant="h5">
            {'✔️'} Identity
          </Typography>
        </Box>

        {/* Placeholder 2 */}
        <Box className="background-checks-text">
          <Typography variant="h5">
            {'✔️'} Association
          </Typography>
        </Box>

        {/* Placeholder 3 */}
        <Box className="background-checks-text">
          <Typography variant="h5">
            {'✔️'} Location
          </Typography>
        </Box>
      </Box>
      <Typography variant="h6" id="pin-modal-title" gutterBottom>
        Enter Pin
      </Typography>
      <TextField
        label="PIN"
        value={pin}
        onChange={handlePinChange}
        onKeyDown={handleKeyDown}
        fullWidth
        variant="outlined"
        margin="normal"
        inputRef={pinInputRef}
      />
      {pinError && (
        <Typography className="error-message" variant="body2">
          {pinError}
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handlePinSubmit}
        fullWidth
        className="popup-button"
      >
        Submit
      </Button>
    </Box>
  )

  const fetchingDataContent = (
    <Box className="pin-modal-box">
      <Box mb={1}>
        <CircularProgress/>
      </Box>
      <Box>
        <Typography variant="body2" gutterBottom>
          Fetching order information...
        </Typography>
      </Box>
    </Box>    
  )

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="pin-modal-title"
      aria-describedby="pin-modal-description"
    >
    {(pinAvailable) ? (defaultModelContent) : (fetchingDataContent)}
    </Modal>
  );
};

export default PinModal;
